export default __webpack_public_path__ + "static/media/TL.bcc866ff.svg";